export default __webpack_public_path__ + "static/media/PORTFOLIO.f094be44.jpg";